/**
 * Filtrous Scroll Animations
 * Intersection Observer for data-animate elements.
 *
 * Usage in Liquid:
 *   <div data-animate="fade-up">Fades up on scroll</div>
 *   <div data-animate="fade-in">Fades in on scroll</div>
 *   <div data-animate="stagger">
 *     <div data-animate-child>Item 1</div>
 *     <div data-animate-child>Item 2</div>
 *     <div data-animate-child>Item 3</div>
 *   </div>
 *
 * CSS (in filtrous-base.css) provides initial hidden state and .filtrous-animated reveal.
 */

(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var elements = document.querySelectorAll('[data-animate]');

    if (!elements.length) return;

    // If reduced motion, reveal everything immediately
    if (prefersReducedMotion) {
      elements.forEach(function (el) {
        el.classList.add('filtrous-animated');
        var children = el.querySelectorAll('[data-animate-child]');
        children.forEach(function (child) {
          child.classList.add('filtrous-animated');
        });
      });
      return;
    }

    // No IntersectionObserver support — reveal all
    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) {
        el.classList.add('filtrous-animated');
        var children = el.querySelectorAll('[data-animate-child]');
        children.forEach(function (child) {
          child.classList.add('filtrous-animated');
        });
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var el = entry.target;
          var animationType = el.getAttribute('data-animate');

          if (animationType === 'stagger') {
            // Stagger child elements with 100ms delay between each
            var children = el.querySelectorAll('[data-animate-child]');
            children.forEach(function (child, index) {
              setTimeout(function () {
                child.classList.add('filtrous-animated');
              }, index * 100);
            });
            // Also animate the parent container
            el.classList.add('filtrous-animated');
          } else {
            el.classList.add('filtrous-animated');
          }

          observer.unobserve(el);
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px',
      }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  // DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
